
import { AutoComplete, Button, Dropdown, Input, Menu, Space, Table, Tag, Tooltip, } from "antd";

import {
  CodepenOutlined,
  ContactsFilled,
  EditOutlined,
  EnvironmentTwoTone,
  MoreOutlined,
  ProfileOutlined,
  SearchOutlined
} from "@ant-design/icons";
import moment from "moment";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useClientStore from "stores/clientStore";

const ClientTable = ({ setVisible, setContacts, editHandler, currentUser }) => {
  const clients = useClientStore((state) => state.clients);
  var clientsList = clients
  const navigate = useNavigate();

  const [filteredClient, setFilteredClient] = useState(false)

  const showContacts = (client) => {
    setVisible(true);

  

    setContacts(client);

  };








  const [currentQuery, setCurrentQuery] = useState('')

  const fuzzyFilter = (query, values) => {
    console.log(query);
    setCurrentQuery(query)
  
 

  
 if (query.length > 2) {
      const results = clientsList.map(client => {
        const name = client?.name || "";
        const nameLower = name.toLowerCase();
        const queryLower = query.toLowerCase();
        
        let relevance = 0;
        
        // Highest priority: Starts with the search term (priority = 2)
        if (nameLower.startsWith(queryLower)) {
          relevance = 2;
        }
        // Second priority: Contains the search term (priority = 1)
        else if (nameLower.includes(queryLower)) {
          relevance = 1;
        }
  
        return {
          ...client,
          relevance,
          originalName: name // keep original name for display
        };
      });
  
      const sortedResults = results
        .filter(result => result.relevance > 0)
        .sort((a, b) => {
          // First sort by relevance
          if (b.relevance !== a.relevance) {
            return b.relevance - a.relevance;
          }
          // For items with same relevance, sort alphabetically
          return a.originalName.localeCompare(b.originalName);
        });
  
      clientsList = [...sortedResults];
      setFilteredClient(sortedResults);
    } else {
      setFilteredClient(false);
    }
  }

  useEffect(() => {

    if (filteredClient.length) {

      fuzzyFilter(currentQuery)

    }


  }, [clients])


  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      key: "name",

      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {



        return (
          <>
            <AutoComplete
          style={{ margin: "1rem", width: "25rem" }}
          autoFocus
          value={selectedKeys[0]}
          options={[...new Set(clients.map(client => client.name))]
            .map(name => ({ value: name }))
            .filter(option => {
              if (!selectedKeys[0]) return true;
              
              const clientName = option.value.toLowerCase();
              const searchText = selectedKeys[0].toLowerCase();
              
              // Check if it starts with the search text or contains it
              const startsWithMatch = clientName.startsWith(searchText);
              const containsMatch = clientName.includes(searchText);
              
              if (startsWithMatch) {
                option.priority = 2; // Highest priority for starts with
              } else if (containsMatch) {
                option.priority = 1; // Lower priority for contains
              } else {
                option.priority = 0; // No match
              }
              
              return startsWithMatch || containsMatch;
            })
            .sort((a, b) => {
              // First sort by priority (2 = starts with, 1 = contains)
              if (b.priority !== a.priority) {
                return b.priority - a.priority;
              }
              // Then sort alphabetically within each priority group
              return a.value.localeCompare(b.value);
            })}

          onSearch={(value) => {
            setSelectedKeys(value ? [value] : []);
          }}
          onSelect={(value) => {
            setSelectedKeys([value]);
            confirm();
          }}
          onChange={(value) => {
            setSelectedKeys(value ? [value] : []);
          }}
          placeholder="Search"
          filterOption={(inputValue, option) => {
            if (!inputValue) return true;
            
            const clientName = option.value.toLowerCase();
            const searchText = inputValue.toLowerCase();
            
            // Create array of matches with their priorities
            const matches = [
              // Priority 1: Starts with search text
              { match: clientName.startsWith(searchText), priority: 2 },
              // Priority 2: Contains search text
              { match: clientName.includes(searchText), priority: 1 }
            ];
            
            // Find the highest priority match
            const highestPriorityMatch = matches.find(m => m.match);
            
            // If we found a match, store its priority for sorting
            if (highestPriorityMatch) {
              option.priority = highestPriorityMatch.priority;
              return true;
            }
            
            return false;
          }}
        />
        <Button
          style={{ margin: "1rem" }}
          type="primary"
          onClick={() => {
            confirm();
          }}
        >
          Search
        </Button>
        <Button
          style={{ marginRight: "1rem" }}
          onClick={() => {
            clearFilters({ confirm: true });
            setFilteredClient(false)
            setSelectedKeys("");
            confirm()
          }}
        >
          Reset
        </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        return record.name.replace(/[^a-zA-Z]/g, "").toLowerCase().includes(value.replace(/[^a-zA-Z]/g, "").toLowerCase());
      },
    },

    {
      title: "Address",
      dataIndex: "address",
      key: "address",
      width: "30%",

      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => {
        return (
          <>
            <Input
              style={{ margin: "1rem", width: "25rem" }}
              autoFocus
              value={selectedKeys[0]}
              onChange={(e) => {
                setSelectedKeys(e.target.value ? [e.target.value] : []);
              }}
              onPressEnter={() => {
                confirm();
              }}
              onBlur={() => {
                confirm();
              }}
              placeholder="Search"
            ></Input>
            <Button
              style={{ margin: "1rem" }}
              type="primary"
              onClick={() => {
                confirm();
              }}
            >
              Search
            </Button>
            <Button
              style={{ marginRight: "1rem" }}
              onClick={() => {
                clearFilters({ confirm: true });
                setSelectedKeys("");
                confirm();
              }}
            >
              Reset
            </Button>
          </>
        );
      },
      filterIcon: () => {
        return <SearchOutlined />;
      },

      onFilter: (value, record) => {
        return record.address.toLowerCase().includes(value.toLowerCase());
      },
    },
    {
      title: "Status",
      key: "4",
      dataIndex: "status",
      render: (_, clients) => {
        const str1 = clients.status;
        const str2 = clients.status.charAt(0).toUpperCase() + str1.slice(1);
        return str2;
      },
      key: "15",
      width: "10%",

      filters: [
        { text: "VIP", value: "VIP" },
        { text: "Ordinary", value: "Ordinary" },
        { text: "Blacklisted", value: "Blacklistedca" },
      ],

      onFilter: (value, record) => record.status.includes(value),
    },

    {
      title: "Contacts",
      dataIndex: "contacts",
      key: "5",
      render: (_, clients) => (
        <>


          <Tooltip
            title={"Contacts"}
          >


            <ContactsFilled
              onClick={() => {
                showContacts(clients);
              }}
            />{" "}
            ({clients?.contacts?.length})

          </Tooltip>



        </>
      ),
      align: "center",
      width: "3%",
    },

    {
      title: "Locations",
      dataIndex: "_id",
      key: "6",
      width: "3%",
      render: (_, clients) => (
        <>


          <Tooltip
            title={"Client Locations"}
          >

            <EnvironmentTwoTone
              onClick={() =>
                navigate("/client/locations/" + clients?._id, {
                  state: { name: clients.name },
                })
              }
            />{" "}
            ({clients?.additional_locations?.length})
          </Tooltip>

        </>
      ),
      align: "center",

    },
    {
      title: "Products",
      dataIndex: "products",
      key: "7",
      render: (_, clients) => (
        <>

          <Tooltip
            title={"Client Products"}
          >
            <CodepenOutlined onClick={() =>
              navigate("/client/products/" + clients?._id, {
                state: {
                  name: clients.name,
                  id: clients._id
                },
              })
            } />{" "}
            ({(clients?.products?.length - (clients.additional_locations?.length+1))<0?0:clients?.products?.length - (clients.additional_locations?.length+1)})
          </Tooltip>

        </>
      ),
      align: "center",
      width: "3%",


    },

    {

      title: "Plan",

      key: "3",
      render: (record, row) => (row?.plan?.name.map((planName) => <Tag>{planName}</Tag>)),
      onFilter: (value, record) => record?.plan?.name?.includes(value),
      filters: [
        { text: "PCB", value: "PCB" },
        { text: "ASC", value: "ASC" },
        { text: "AMC", value: "AMC" },
      ],


    },
    

    {
      title: "Next Maintenance ",
      dataIndex: "next_maintenance_date",
      key: "3",
      render: (record, row) => (row.is_active && row.maintenance_interval) ? moment.utc(record).format("DD-MM-YYYY") : '',
      width: "2rem",
    },
    


    {
      title: "Action",
      key: "dropDown",
      render: (_, clients) => (

        <>  <Dropdown
          overlay={
            <Menu>
              <Menu.Item key="1">

                <Button
                  type="link"
                  icon={<EditOutlined />}
                  hidden={!currentUser.privileges.includes('client_management')} onClick={() => editHandler(clients)}
                >
                  Update Client

                </Button>

              </Menu.Item>
              <Menu.Item key="2">
                <Button
                  type="link"
                  icon={<ProfileOutlined />}
                  disabled={!currentUser.privileges.includes('client_management')}
                  onClick={() =>
                    navigate("/client/products/" + clients?._id, {
                      state: {
                        name: clients.name,
                        id: clients._id,
                        ASC_AMC: true,

                      },
                    })
                  } >Update Plan

                </Button>
              </Menu.Item>
            </Menu>
          }
        >
          <Button

            style={{ borderRadius: '5px', width: '1.8rem' }} icon={
              <MoreOutlined />} >

          </Button>
        </Dropdown>
        </>



      ),
      align: "center",
    },




  ];

  return (
    <>
      <Space
        style={{
          marginBottom: 16,
        }}
      ></Space>

      <Table rowKey={"_id"} columns={columns} dataSource={filteredClient ? filteredClient : clientsList} />
    </>
  );
};

export default ClientTable;
